import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    locationId: Number
  }

  select(event) {
    const selectedId = this.locationIdValue

    document.querySelectorAll("input[name$='[is_primary]']").forEach(input => {
      input.value = "false"
    })

    document.querySelectorAll("input[name$='[id]']").forEach(idInput => {
      if (idInput.value == selectedId) {
        const isPrimaryInput = idInput
          .closest("div")
          .querySelector("input[name$='[is_primary]']")
        if (isPrimaryInput) {
          isPrimaryInput.value = "true"
        }
      }
    })

    const selectedElement = event.currentTarget
    const previewContainer = document.querySelector("#orgLocations .detail-location")
    if (previewContainer && selectedElement) {
      previewContainer.innerHTML = selectedElement.querySelector(".org-location").innerHTML
    }
  }
}
